import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import useSafePreviousNavigate from '@sorare/core/src/hooks/useSafePreviousNavigate';
import { glossary } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const messages = defineMessages({
  back: {
    id: 'CompetitionDetails.Layout.Back',
    defaultMessage: 'Back',
  },
});

const Wrapper = styled(Container)`
  padding-top: var(--triple-unit);
`;

const BackButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  gap: var(--double-unit);
  padding: 0 var(--unit);
  color: var(--c-neutral-1000);
  border-radius: var(--unit);
  &:hover,
  &:focus {
    color: var(--c-brand-600);
  }
`;

const DesktopText = styled.span`
  flex: 1 1 0;
  font: var(--t-bold) var(--t-16);
  padding: var(--half-unit) 0;
  text-align: start;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: none;
  @media ${laptopAndAbove} {
    display: inline;
  }
`;

const MobileText = styled(DesktopText)`
  display: inline;
  @media ${laptopAndAbove} {
    display: none;
  }
`;

type Props = { children: ReactNode };

export const BackLink = ({ children }: Props) => {
  const { formatMessage } = useIntl();
  const goBack = useSafePreviousNavigate('..');
  return (
    <Wrapper>
      <BackButton onClick={goBack} aria-label={formatMessage(glossary.back)}>
        <FontAwesomeIcon icon={faAngleLeft} />
        <MobileText>{children}</MobileText>
        <DesktopText>
          <FormattedMessage {...messages.back} />
        </DesktopText>
      </BackButton>
    </Wrapper>
  );
};
